module.exports = __webpack_public_path__ + "static/media/question-own.12f464cf.gif";